import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logoUrl from '../assets/CF3.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Главная' },
    { path: '/product', label: 'Продукт' },
    { path: '/roadmap', label: 'Дорожная карта' },
    { path: '/contacts', label: 'Контакты' },
  ];

  return (
    <header style={styles.header}>
      <div className="container">
        <div style={styles.headerContent}>
          {/* Логотип */}
          <Link to="/" style={styles.logo}>
            <img 
              src={logoUrl} 
              alt="Сыролёт" 
              width={180}
              height={80}
              style={styles.logoImage}
            />
            <span style={styles.logoText}>Сыролёт</span>
          </Link>

          {/* Навигация для десктопа */}
          <nav style={styles.desktopNav}>
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  color: isActive ? '#3B82F6' : '#CBD5E1',
                  fontWeight: isActive ? '900' : '500',
                })}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Кнопка для мобильного меню */}
          <button 
            style={styles.mobileMenuBtn}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Меню"
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>
        </div>

        {/* Мобильное меню */}
        {isMenuOpen && (
          <nav style={styles.mobileNav}>
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                style={({ isActive }) => ({
                  ...styles.mobileNavLink,
                  backgroundColor: isActive ? '#3B82F6' : 'transparent',
                  color: isActive ? 'white' : '#CBD5E1',
                })}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        )}
      </div>

      <style>{`
        /* Подключение шрифта Advent Pro */
        @import url('https://fonts.googleapis.com/css2?family=Advent+Pro:wght@400;500;600;700&display=swap');

        @media (min-width: 768px) {
          .desktop-nav {
            display: flex !important;
          }
          .mobile-menu-btn {
            display: none !important;
          }
          .mobile-nav {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

const styles = {
  header: {
    background: 'rgba(15, 23, 42, 0.95)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    padding: '1rem 0',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    textDecoration: 'none',
    position: 'relative',
    padding: '0.5rem',
    transition: 'transform 0.3s ease',
  },
  logoImage: {
    objectFit: 'contain',
    display: 'block',
    filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))',
  },
  logoText: {
    fontSize: '2.5rem',
    fontWeight: '700',
    color: '#FFD700',
    letterSpacing: '1px',
    fontFamily: "'Advent Pro', sans-serif", // Добавлен шрифт Advent Pro
  },
  desktopNav: {
    display: 'none',
    gap: '2rem',
  },
  navLink: {
    textDecoration: 'none',
    padding: '0.5rem 0',
    position: 'relative',
    transition: 'color 0.3s ease',
  },
  mobileMenuBtn: {
    display: 'block',
    background: 'rgba(30, 41, 59, 0.8)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    color: '#FFFFFF',
    cursor: 'pointer',
    padding: '0.5rem',
    fontSize: '1.5rem',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
  },
  mobileNav: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    background: 'rgba(15, 23, 42, 0.95)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    marginTop: '0.5rem',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    animation: 'fadeIn 0.3s ease-out',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.5)',
  },
  mobileNavLink: {
    padding: '0.75rem 1rem',
    color: '#CBD5E1',
    textDecoration: 'none',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    border: '1px solid transparent',
  },
};

export default Header;
